import { useSyncExternalStore } from 'react';
import { onlineManager } from '@tanstack/react-query';

const subscribe = (onChange: () => void) => {
  window.addEventListener('online', onChange);
  window.addEventListener('offline', onChange);
  const unsubscribe = onlineManager.subscribe(onChange);
  return () => {
    window.removeEventListener('online', onChange);
    window.removeEventListener('offline', onChange);
    unsubscribe();
  };
};

/** Can be used outside NetworkStatusProvider. Checks navigator.onLine because onlineManager reports online when the app starts offline. */
export const useIsOnline = () =>
  useSyncExternalStore(
    subscribe,
    () => navigator.onLine && onlineManager.isOnline()
  );
